import React from 'react';
import styles from './Container.module.scss';
import clsx from 'clsx';

export const Container = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={clsx(styles.wrapper, className && className)}>{children}</div>
  );
};

export default Container;
